import styled from 'styled-components'
import { COLORS } from '../../../styles/colors'

export const StyledDatePicker = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 8px;
`

export const DropdownContainer = styled.div<{
	$isOpen: boolean
	$top?: number
	$left?: number
}>`
	position: fixed;
	top: ${({ $top }) => ($top !== undefined ? `${$top}px` : 'auto')};
	left: ${({ $left }) => ($left !== undefined ? `${$left}px` : 'auto')};
	z-index: 9999;
	display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
	flex-direction: row;
	background: ${COLORS.white};
	border-radius: 12px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	overflow: hidden;
`

export const ResetButton = styled.div`
	display: flex;
	align-items: center;
`
